import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface HeadingBaseProps {
  $noMargin?: boolean;
  $margin?: 'none' | 'small';
}

export const HeadingBase = styled.div.withConfig({ componentId: 'sc-du1sgw-0' })<HeadingBaseProps>`
    display: block;
    margin-top: 0;
    margin-bottom: var(--_margin, ${size(2)});
    line-height: 1.3;
    font-weight: var(--font-weight-bold);
    letter-spacing: -0.01em;
    text-wrap: balance;

    ${({ $noMargin }) =>
      $noMargin &&
      css`
            margin-bottom: 0;
        `}

    ${({ $margin }) =>
      $margin === 'none'
        ? css`
                  --_margin: 0;
              `
        : $margin === 'small'
          ? css`
                  --_margin: ${size(1)};
              `
          : undefined}
`;

export const H1 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h1',
})).withConfig({ componentId: 'sc-du1sgw-1' })`
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    letter-spacing: -0.02em;
`;

export const H2 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h2',
})).withConfig({ componentId: 'sc-du1sgw-2' })`
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
`;

export const H3 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h3',
})).withConfig({ componentId: 'sc-du1sgw-3' })`
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
`;

export const H4 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h4',
})).withConfig({ componentId: 'sc-du1sgw-4' })`
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
`;

export const H5 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h5',
})).withConfig({ componentId: 'sc-du1sgw-5' })`
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
`;

export const H6 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h6',
})).withConfig({ componentId: 'sc-du1sgw-6' })`
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    letter-spacing: 0.15em;
    text-transform: uppercase;
    opacity: 0.8;
`;

export const HeadingTail = styled.span.withConfig({ componentId: 'sc-du1sgw-7' })`
    font-weight: var(--font-weight-light);
`;
